import React from 'react';
import PropTypes from 'prop-types';
import Diagram from '../../Components/Diagram';
import Turnout from '../../Components/Turnout';
import { Subtitle, Title } from '../../Components/Header';
import { percentFormat } from '../../Utils/NumberFormatting';
import { Clearfix } from '../../Symbols/layout'
import { getHasElectionStarted } from '../../Utils/Getters';

export default class Overview extends React.PureComponent {
	getSortedParties = (parties) => {
		if (!getHasElectionStarted(this.props.meta)) {
			return parties.slice().sort((a, b) => a.name.localeCompare(b.name));
		}
		return parties.slice().sort((a, b) => b.percent - a.percent);
	};

	render() {
		return <>
			<Title.Input>Krajské volby {this.props.year}</Title.Input>
			<Subtitle.Input>Celkový přehled</Subtitle.Input>

			{!this.props.hasData && <p>
				Načítám data
			</p>}

			{this.props.hasData && !getHasElectionStarted(this.props.meta) && <p>
				Zatím nebyly sečteny žádné hlasy.
			</p>}
			{
				getHasElectionStarted(this.props.meta) &&
				<Turnout
					turnout={this.props.meta.turnout}
					count={this.props.meta.count}
				/>
			}
			<Diagram
				title="Kolik získaly strany hlasů"
				items={this.getSortedParties(this.props.parties)}
				getValue={item => item.percent}
				renderValue={item => percentFormat(item.percent)}
			/>
			<Clearfix />
		</>;
	}
}

Overview.propTypes = {
	rootUrl: PropTypes.string.isRequired,
	parties: PropTypes.arrayOf(PropTypes.object).isRequired,
	meta: PropTypes.shape({
		turnout: PropTypes.number.isRequired,
		count: PropTypes.number.isRequired
	}),
	hasData: PropTypes.bool.isRequired,
	year: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]).isRequired
}
